import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { StorageService } from './storage-service.service';
import { SomeProvider } from './some/some';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(
    private myService: SomeProvider,
    private storage: StorageService,
    private router: Router
  ) { }

  async canActivate(): Promise<boolean | UrlTree> {
    if (await this.isAuthenticated()) {
      return true;
    }

    // Redirect al login se non autenticato
    return this.router.parseUrl('/welcome');
  }

  async isAuthenticated(): Promise<boolean> {
    if (this.myService.isUserLoggedIn) {
      return true;
    }

    const token = await this.storage.get('token');
    const isAuthenticated = this.hasValidToken(token);

    if (isAuthenticated) {
      this.myService.tokenValue = token;
    }
    this.myService.isUserLoggedIn = isAuthenticated;
    return isAuthenticated;
  }

  private hasValidToken(token: unknown): token is string {
    if (typeof token !== 'string') {
      return false;
    }

    const normalizedToken = token.trim();
    return normalizedToken !== '' &&
      normalizedToken.toLowerCase() !== 'null' &&
      normalizedToken.toLowerCase() !== 'undefined';
  }
}
